const getters = {
  isLogin: state => state.user.isLogin,
  user_info: state => state.user.user_info
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js